module.exports = __webpack_public_path__ + "img/icon-question-free-question_active.6feda725.svg";